import { render, staticRenderFns } from "./BaseBtn.vue?vue&type=template&id=95fe9f2c"
import script from "./BaseBtn.vue?vue&type=script&lang=ts"
export * from "./BaseBtn.vue?vue&type=script&lang=ts"
import style0 from "./BaseBtn.vue?vue&type=style&index=0&id=95fe9f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports